define("calendar/components/calendar/future-trends/trend", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "moment", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _moment, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"moment",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cCA--futureTrends__content__item">
    <div class="cCA--futureTrends__content__item__iconContainer">
      {{svg-jar "hashtag" class="u--text--base cCA--futureTrends__content__item__icon"}}
    </div>
    <div class="cCA--futureTrends__content__item__text">
      <div>
        <h3 class="u--m__t__0">{{@trend.name}}</h3>
        <p class="u--m__b__xs">{{@trend.explanation}}</p>
      </div>
      <div class="u--flex u--flex__justify--end u--flex__alignSelf--end">
        <Shared::Ui::Button
          @onClick={{this.schedulePostWithHashtags}}
          @text={{t "calendar.future_trends.create_post"}}
          @variant="unstyled"
          class={{concat-classes "u--text--bold" (if this.isButtonDisabled "is--disabled")}}
        >
          <span>{{t "calendar.future_trends.create_post"}}</span>
          {{svg-jar "arrow-right" class="o--icon o--icon--sm u--m__l__xs u--flex__alignSelf--center"}}
          {{#if this.isButtonDisabled}}
            <EmberTooltip @event="hover">
              {{t "calendar.future_trends.create_post_tooltip"}}
            </EmberTooltip>
          {{/if}}
        </Shared::Ui::Button>
      </div>
    </div>
  </div>
  */
  {
    "id": "u7q+fNIc",
    "block": "[[[10,0],[14,0,\"cCA--futureTrends__content__item\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCA--futureTrends__content__item__iconContainer\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"hashtag\"],[[\"class\"],[\"u--text--base cCA--futureTrends__content__item__icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cCA--futureTrends__content__item__text\"],[12],[1,\"\\n    \"],[10,0],[12],[1,\"\\n      \"],[10,\"h3\"],[14,0,\"u--m__t__0\"],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__xs\"],[12],[1,[30,1,[\"explanation\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--flex u--flex__justify--end u--flex__alignSelf--end\"],[12],[1,\"\\n      \"],[8,[39,1],[[16,0,[28,[37,2],[\"u--text--bold\",[52,[30,0,[\"isButtonDisabled\"]],\"is--disabled\"]],null]]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"schedulePostWithHashtags\"]],[28,[37,4],[\"calendar.future_trends.create_post\"],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"calendar.future_trends.create_post\"],null]],[13],[1,\"\\n        \"],[1,[28,[35,0],[\"arrow-right\"],[[\"class\"],[\"o--icon o--icon--sm u--m__l__xs u--flex__alignSelf--center\"]]]],[1,\"\\n\"],[41,[30,0,[\"isButtonDisabled\"]],[[[1,\"          \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,4],[\"calendar.future_trends.create_post_tooltip\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@trend\"],false,[\"svg-jar\",\"shared/ui/button\",\"concat-classes\",\"if\",\"t\",\"ember-tooltip\"]]",
    "moduleName": "calendar/components/calendar/future-trends/trend.hbs",
    "isStrictMode": false
  });
  let FutureTrendsTrendComponent = _exports.default = (_dec = (0, _service.service)('schedule/post'), _dec2 = (0, _object.computed)('selectedSocialProfiles'), (_class = class FutureTrendsTrendComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "schedulePost", _descriptor, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);
      _initializerDefineProperty(this, "router", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
    }
    get isButtonDisabled() {
      return Boolean(!this.selectedSocialProfiles.profiles.length);
    }
    schedulePostWithHashtags() {
      if (this.isButtonDisabled) {
        return;
      }
      this.schedulePost.setAutoIncludeHashtags([this.args.trend.name]);
      const isListView = this.router.currentRouteName?.includes('list');
      const singleOrMultiPost = this.selectedSocialProfiles.profiles.length > 1 ? _constants.ProfilePostType.Multi : _constants.ProfilePostType.Single;
      const targetURL = isListView ? `cluster.schedule.list.post.${singleOrMultiPost}` : `cluster.schedule.calendar.post.${singleOrMultiPost}`;
      this.segment.track('started-scheduling-post', {
        area: 'future_insight'
      });
      this.router.transitionTo(targetURL, _constants.TEXT_POST_TYPE, {
        queryParams: {
          autoIncludeHashtags: true,
          backTo: isListView ? 'cluster.schedule.list' : 'cluster.schedule.calendar',
          draft: true,
          scheduledTime: (0, _moment.default)().unix()
        }
      });
      this.args.closeAction();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "schedulePost", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "isButtonDisabled", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "isButtonDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "schedulePostWithHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "schedulePostWithHashtags"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FutureTrendsTrendComponent);
});